import Vue from "vue";
import { store } from "../store/store.js";
import Router from "vue-router";

import LoginPage from "@/views/Auth/Login";
import DashboardMain from "@/views/Dashboard/Main";

// Edit Profile
const EditProfileMain = () => import("@/views/Auth/Main");
import EditProfile from "@/views/Auth/EditProfile";

// Error Pages
import NotFound from "@/views/Error/SmallNotFound";
import PageNotFound from "@/views/Error/PageNotFound";

// Highlight
const HighlightMain = () => import("@/views/Dashboard/Highlight/Main");
import HighlightLabelMaker from "@/views/Dashboard/Highlight/HighlightLabelMaker";

// Plan Alokasi
const PlanAlokasiMain = () => import("@/views/Dashboard/PlanAlokasi/Main");
import PlanAlokasi from "@/views/Dashboard/PlanAlokasi/PlanAlokasi";

// Plan Alokasi Muat
const PlanAlokasiMuatMain = () =>
  import("@/views/Dashboard/PlanAlokasiMuat/Main");
import PlanAlokasiMuat from "@/views/Dashboard/PlanAlokasiMuat/PlanAlokasiMuat";

// Create Alokasi
const CreateAlokasiMain = () => import("@/views/Dashboard/CreateAlokasi/Main");
import CreateAlokasi from "@/views/Dashboard/CreateAlokasi/CreateAlokasi";

// Edit Alokasi
const EditAlokasiMain = () => import("@/views/Dashboard/EditAlokasi/Main");
import EditAlokasi from "@/views/Dashboard/EditAlokasi/EditAlokasi";

// Register Muat
const RegisterMuatMain = () => import("@/views/Dashboard/RegisterMuat/Main");
import RegisterMuat from "@/views/Dashboard/RegisterMuat/RegisterMuat";
import CUMuat from "@/views/Dashboard/RegisterMuat/CUMuat";

// Bongkar Muat
const BongkarMuatMain = () => import("@/views/Dashboard/BongkarMuat/Main");
import BongkarMuat from "@/views/Dashboard/BongkarMuat/BongkarMuat";

// Create Bongkar
const CreateBongkarMain = () => import("@/views/Dashboard/CreateBongkar/Main");
import CreateBongkar from "@/views/Dashboard/CreateBongkar/CreateBongkar";

// Edit Bongkar
const EditBongkarPageMain = () =>
  import("@/views/Dashboard/EditBongkarPage/Main");
import EditBongkarPage from "@/views/Dashboard/EditBongkarPage/EditBongkarPage";

// Service Rate
const ServiceRateMain = () => import("@/views/Dashboard/ServiceRate/Main");
import ServiceRate from "@/views/Dashboard/ServiceRate/ServiceRate";

// Leadtime
const LeadtimeMain = () => import("@/views/Dashboard/Leadtime/Main");
import Leadtime from "@/views/Dashboard/Leadtime/Leadtime";
import LeadtimeDetailReportDetails from "@/views/Dashboard/Leadtime/LeadtimeDetailReportDetails";

// Defect
const DefectMain = () => import("@/views/Dashboard/Defect/Main");
import Defect from "@/views/Dashboard/Defect/Defect";
import DefectDetails from "@/views/Dashboard/Defect/DefectDetails";

// NOS
const NosMain = () => import("@/views/Dashboard/NOS/Main");
import Nos from "@/views/Dashboard/NOS/NOS";
import CreateNos from "@/views/Dashboard/NOS/CreateNOS";
import EditNos from "@/views/Dashboard/NOS/EditNOS";

// Truck List
const TruckListMain = () => import("@/views/Dashboard/TruckList/Main");
import TruckList from "@/views/Dashboard/TruckList/TruckList";
import TruckDetails from "@/views/Dashboard/TruckList/TruckDetails";

// Create Truck
const CreateTruckMain = () => import("@/views/Dashboard/CreateTruck/Main");
import CreateTruck from "@/views/Dashboard/CreateTruck/CreateTruck";

// Driver List
const DriverListMain = () => import("@/views/Dashboard/DriverList/Main");
import DriverList from "@/views/Dashboard/DriverList/DriverList";
import DriverDetails from "@/views/Dashboard/DriverList/DriverDetails";

// Create Driver
const CreateDriverMain = () => import("@/views/Dashboard/CreateDriver/Main");
import CreateDriver from "@/views/Dashboard/CreateDriver/CreateDriver";

// CustomerActivities
const CustomerActivitiesMain = () =>
  import("@/views/Dashboard/CustomerActivities/Main");
import CustomerActivities from "@/views/Dashboard/CustomerActivities/CustomerActivities";

// Consumer Insights
const ConsumerInsightsMain = () =>
  import("@/views/Dashboard/ConsumerInsights/Main");
import ConsumerInsights from "@/views/Dashboard/ConsumerInsights/ConsumerInsights";

// Reports
// const ReportsMain = () => import("@/views/Dashboard/Reports/Main");
// import ReportCustomer from "@/views/Dashboard/Reports/ReportCustomer2";
// import ReportLabelMaker from "@/views/Dashboard/Reports/ReportLabelMaker";
// import ReportOilMaker from "@/views/Dashboard/Reports/ReportOilMaker";
// import ReportQrCode from "@/views/Dashboard/Reports/ReportQrCode";
// import ReportSuspect from "@/views/Dashboard/Reports/ReportSuspect";

// Settings
const SettingsMain = () => import("@/views/Dashboard/Settings/Main");
//User Management
const UserManagementMain = () =>
  import("@/views/Dashboard/Settings/UserManagement/Main");
import DashboardUserUM from "@/views/Dashboard/Settings/UserManagement/DashboardUserUM";
import AddPlantUM from "@/views/Dashboard/Settings/UserManagement/AddPlant";
import DashboardGudang from "@/views/Dashboard/Settings/UserManagement/DashboardGudang";
import RestorePlant from "@/views/Dashboard/Settings/UserManagement/children/RestorePlant";
import RestoreUser from "@/views/Dashboard/Settings/UserManagement/children/RestoreUser";
import PenindakanAppUM from "@/views/Dashboard/Settings/UserManagement/PenindakanAppUM";
import Holiday from "@/views/Dashboard/Settings/Holiday";

import LeadtimeSettings from "@/views/Dashboard/Settings/LeadtimeSettings/DashboardLeadtime";
// Validasi Kedatangan Produk

// Daftar TO

// Rute Ekspedisi

// Antrian Truk

// Settings

// Create a simple user object with a role property
const currentUser = {
  role: "ekspedisi1", // Change this to the actual role of the logged-in user
};

// Implement a function to retrieve the current user
const getCurrentUser = () => {
  return currentUser;
};

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
      meta: {
        requiresAuth: false,
      },
    },

    //Edit Profile
    {
      path: "",
      component: DashboardMain,
      children: [
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: EditProfile,
          meta: {
            requiresAuth: true,
            sidebar: true,
          },
        },
      ],
    },

    //Dashboard Start
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardMain,
      children: [
        //Default Fallback
        {
          path: "",
          name: "Dashboard",
          component: NotFound,
        },

        //Highlight
        {
          path: "highlight",
          component: HighlightMain,
          children: [
            {
              path: "",
              name: "Highlight",
              component: HighlightLabelMaker,
            },
          ],
        },

        //PlanAlokasi
        {
          path: "plan-alokasi",
          component: PlanAlokasiMain,
          children: [
            {
              path: "",
              name: "PlanAlokasi",
              component: PlanAlokasi,
              meta: {
                requiresAuth: true,
                allowedRoles: ["ekspedisi1"],
              },
            },
          ],
        },

        //PlanAlokasiMuat
        {
          path: "plan-alokasi-muat",
          component: PlanAlokasiMuatMain,
          children: [
            {
              path: "",
              name: "PlanAlokasiMuat",
              component: PlanAlokasiMuat,
              meta: {
                requiresAuth: true,
                allowedRoles: ["admin_md"],
              },
            },
          ],
        },

        //CreateAlokasi
        {
          path: "create-alokasi",
          component: CreateAlokasiMain,
          children: [
            {
              path: "",
              name: "CreateAlokasi",
              component: CreateAlokasi,
              meta: {
                requiresAuth: true,
                allowedRoles: ["admin_md"],
              },
            },
          ],
        },

        //EditAlokasi
        {
          path: "edit-alokasi",
          component: EditAlokasiMain,
          children: [
            {
              path: "",
              name: "EditAlokasi",
              component: EditAlokasi,
              meta: {
                requiresAuth: true,
                allowedRoles: ["admin_md"],
              },
            },
          ],
        },

        //RegisterMuat
        {
          path: "register-muat",
          component: RegisterMuatMain,
          children: [
            {
              path: "",
              name: "RegisterMuatList",
              component: RegisterMuat,
            },
            {
              path: "create",
              name: "CMuat",
              component: CUMuat,
            },
            {
              path: "edit",
              name: "UMuat",
              component: CUMuat,
            },
          ],
        },

        //BongkarMuat
        {
          path: "bongkar-muat",
          component: BongkarMuatMain,
          children: [
            {
              path: "",
              name: "BongkarMuat",
              component: BongkarMuat,
            },
            {
              path: "create-bongkar",
              component: CreateBongkarMain,
              children: [
                {
                  path: "",
                  name: "CreateBongkar",
                  component: CreateBongkar,
                },
              ],
            },
            {
              path: "edit-bongkar",
              component: EditBongkarPageMain,
              children: [
                {
                  path: "/dashboard/edit-bongkar/:id",
                  name: "EditBongkar",
                  component: EditBongkarPage,
                },
              ],
            },
          ],
        },

        //ServiceRate
        {
          path: "service-rate",
          component: ServiceRateMain,
          children: [
            {
              path: "",
              name: "ServiceRate",
              component: ServiceRate,
            },
          ],
        },

        //Leadtime
        {
          path: "leadtime",
          component: LeadtimeMain,
          children: [
            {
              path: "",
              name: "Leadtime",
              component: Leadtime,
            },
            {
              path: "detail/:nopol",
              name: "LeadtimeDetailReportDetails",
              component: LeadtimeDetailReportDetails,
            },
          ],
        },

        //Defect
        {
          path: "defect",
          component: DefectMain,
          children: [
            {
              path: "",
              name: "Defect",
              component: Defect,
            },
            {
              path: "detail",
              name: "DefectDetails",
              component: DefectDetails,
            },
          ],
        },

        //NOS
        {
          path: "nos",
          component: NosMain,
          children: [
            {
              path: "",
              name: "NOS",
              component: Nos,
            },
            {
              path: "create-nos",
              name: "CreateNOS",
              component: CreateNos,
            },
            {
              path: "edit-nos",
              name: "EditNOS",
              component: EditNos,
            },
          ],
        },

        //TruckList
        {
          path: "truck-list",
          component: TruckListMain,
          children: [
            {
              path: "",
              name: "TruckList",
              component: TruckList,
            },
            {
              path: "detail",
              name: "TruckDetails",
              component: TruckDetails,
            },
          ],
        },

        //CreateTruck
        {
          path: "create-truck",
          component: CreateTruckMain,
          children: [
            {
              path: "",
              name: "CreateTruck",
              component: CreateTruck,
            },
          ],
        },

        //TruckDetailsID
        {
          path: "/dashboard/truck-detail/:id",
          name: "TruckDetails",
          component: TruckDetails,
          props: true, // Pass route params as props to the component
        },

        //DriverList
        {
          path: "driver-list",
          component: DriverListMain,
          children: [
            {
              path: "",
              name: "DriverList",
              component: DriverList,
              beforeEnter: (to, from, next) => {
                console.log("Route Guard for DriverList");
                const currentUser = getCurrentUser(); // Make sure this function returns the correct user object with roles.
                if (currentUser && currentUser.role === "ekspedisi1") {
                  console.log("Allowed access to DriverList for ekspedisi1");
                  next();
                } else {
                  console.log("Access Denied for DriverList");
                  next("/access-denied"); // You can create an access-denied route for this purpose.
                }
              },
            },
            {
              path: "detail",
              name: "DriverDetails",
              component: DriverDetails,
            },
          ],
        },

        //CreateMuat
        {
          path: "create-driver",
          component: CreateDriverMain,
          children: [
            {
              path: "",
              name: "CreateDriver",
              component: CreateDriver,
            },
          ],
        },

        //Activities
        {
          path: "customer-activities",
          component: CustomerActivitiesMain,
          children: [
            {
              path: "",
              name: "CustomerActivities",
              component: CustomerActivities,
            },
          ],
        },

        //Consumer Insights
        {
          path: "consumer-insights",
          component: ConsumerInsightsMain,
          children: [
            {
              path: "",
              name: "ConsumerInsights",
              component: ConsumerInsights,
            },
          ],
        },

        //Reports
        // {
        //     path: "reports",
        //     component: ConsumerInsightsMain,
        //     children: [
        //         {
        //             path: "",
        //             name: "Reports",
        //             component: NotFound,
        //         },
        //         {
        //             path: "customer",
        //             name: "ReportCustomer",
        //             component: ReportCustomer,
        //         },
        //         {
        //             path: "label-maker",
        //             name: "ReportLabelMaker",
        //             component: ReportLabelMaker,
        //         },
        //         {
        //             path: "oil-maker",
        //             name: "ReportOilMaker",
        //             component: ReportOilMaker,
        //         },
        //         {
        //             path: "qrcode",
        //             name: "ReportQrCode",
        //             component: ReportQrCode,
        //         },
        //         {
        //             path: "suspect",
        //             name: "ReportSuspect",
        //             component: ReportSuspect,
        //         },
        //     ],
        // },

        //Settings
        {
          path: "settings",
          component: SettingsMain,
          children: [
            {
              path: "",
              name: "Settings",
              component: NotFound,
            },
            {
              path: "user-management",
              component: UserManagementMain,
              children: [
                {
                  path: "",
                  name: "UserManagement",
                  component: NotFound,
                },
                {
                  path: "dashboard-user",
                  name: "DashboardUserManagement",
                  component: DashboardUserUM,
                },
                {
                  path: "add-plant",
                  name: "AddPlant",
                  component: AddPlantUM,
                },
                {
                  path: "penindakan-app",
                  name: "PenindakanAppUserManagement",
                  component: PenindakanAppUM,
                },
                {
                  path: "restore-plant", // Make sure the path is correctly set
                  name: "UserManagementRestorePlant",
                  component: RestorePlant, // Ensure the component is correctly imported
                },
                {
                  path: "restore-user", // Make sure the path is correctly set
                  name: "UserManagementRestoreUser",
                  component: RestoreUser, // Ensure the component is correctly imported
                },
              ],
            },
            {
              path: "holiday",
              component: Holiday,
            },
            {
              path: "gudang",
              name: "Gudang",
              component: DashboardGudang
            },
            {
              path: "leadtime-settings",
              component: LeadtimeSettings
            }
          ],
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },

    //Error 404 Page Not Found
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
